
import * as dom from '../../modules/wpstg-dom-utils.js';
import WPStagingCommon from '../../wpstg.js';

export default class WpstgSyncAccount {
  constructor(
  ) {
    this.syncAccount();
  }

  syncAccount() {
    const $that = this;

    dom.addEvent(document.body, 'click', '.wpstg-sync-account', function(e) {
      const $this = dom.qs('.wpstg-sync-account');
      const dataset = $this.dataset;
      const html = '<p class=\'wpstg-push-confirmation-message\'> ' + dataset.alertBody + '</p>';
      $that.confirmModal(dataset.alertTitle, html, dataset.confirmBtnText, 'wpstg-confirm-sync-account').then(function(result) {
        const cloneID = dataset.clone;

        if (result.value) {
          WPStaging.ajax({
            action: 'wpstg_sync_account',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            clone: cloneID,
          }, function(response) {
            if (response.data.message) {
              if (response.success) {
                WPStagingCommon.showSuccessModal(response.data.message);
              } else {
                WPStagingCommon.showErrorModal(response.data.message);
              }
            }
          }, 'json', false);
          return;
        }
      });
    });
  };

  /**
   * A confirmation modal
   *
   * @param html
   * @param confirmText
   * @param confirmButtonClass
   * @return Promise
   */
  confirmModal(title, html, confirmText, confirmButtonClass) {
    return WPStagingCommon.getSwalModal(false, {
      container: 'wpstg-swal-push-container',
      confirmButton: confirmButtonClass + ' wpstg--btn--confirm wpstg-blue-primary wpstg-button wpstg-link-btn',
    }).fire({
      title: title,
      icon: 'warning',
      html: html,
      width: '750px',
      focusConfirm: false,
      confirmButtonText: confirmText,
      showCancelButton: true,
    });
  };
}
